<div class="Error404">
    <h1 class="code"> 404 </h1>
    <h2 class="text-secondary heading">{{'PAGE_NOT_FOUND.HEADING'| translate}}</h2>
  <p class="description">
    {{'PAGE_NOT_FOUND.DESCRIPTION'| translate}}
    <a (click)="goToPreviousUrl()">{{'PAGE_NOT_FOUND.ACTION1'| translate}} </a>{{'PAGE_NOT_FOUND.SUBTEXT1'| translate}}
    <a (click)="goToHome()"> {{'PAGE_NOT_FOUND.ACTION2'| translate}} </a> {{'PAGE_NOT_FOUND.SUBTEXT2'| translate}}
  </p>
</div>
